<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <el-table ref="multipleTable" size="small" :data="list" style="width: 100%; margin-top:20px;">
      <el-table-column prop="id" label="店铺ID" fixed />
      <el-table-column prop="name" label="店铺名称" />
      <el-table-column prop="city" label="店铺城市" />
      <el-table-column prop="address" width="300px" label="店铺详细地址" />
      <el-table-column prop="createTime" label="创建时间" />
      <el-table-column fixed="right" width="200px" label="操作">
        <template slot-scope="{row}">
          <el-button size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="text" class="link-color" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background class="fixed-below" :page-size="pageSize" layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50, 100]" :current-page.sync="pageNum" :total="total" @size-change="handleSizeChange" @current-change="getList" />
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSucces" />
  </div>
</template>
<script>
import Dialog from '@/components/Dialog';
export default {
  components: { Dialog },
  data() {
    return {
      list: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      formDialogShow: false,
      information: {},
    };
  },
  computed: {
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    getList() {
      this.$Api.activity.addressList({
        limit: this.pageSize,
        current: this.pageNum,
      },).then(({ data, total }) => {
        this.list = data;
        this.total = total;
      });
    },
    edit(row) {
      this.$router.push({ path: '/store/edit', query: { id: row.id } });
    },
    add() {
      this.$router.push({ path: '/store/add' });
    },
    remove(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        // subTitle: `是否确认删除店铺ID为“${row.id}”的数据项？`,
        subTitle: '删除后小程序用户将无法查看该店铺，请确认是否删除',
      };
    },
    submitSucces(operation) {
      if (operation === 'delete') {
        this.$Api.activity.deleteAddress(this.currentID).then(() => {
          this.$message.success('删除成功');
          this.getList();
        });
      }
    },
  },
};

</script>
